var React = require('react');
var Link = require('react-router').Link;

var encodeSlug = require('../room-slug');
var roomNames = require('../rooms-to-prerender');
var INDEX = require('../rooms-index');

var DEFAULT_TITLE = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';

var AllRooms = React.createClass({
  componentDidMount: function() {
    document.title = INDEX.title;
  },
  componentWillUnmount: function() {
    document.title = DEFAULT_TITLE;
  },
  render: function() {
    var groups = INDEX.build(roomNames).map(function(group) {
      var hubBits = [];
      if (group.stateHub) {
        hubBits.push(<Link key="state" to={group.stateHub.to}>{group.stateHub.label}</Link>);
      }
      group.hubs.forEach(function(hub) {
        if (hubBits.length) hubBits.push(<span key={'s-' + hub.to} aria-hidden="true"> · </span>);
        hubBits.push(<Link key={hub.to} to={hub.to}>{hub.label}</Link>);
      });
      return (
        <section className="guide-section" key={group.state}>
          <h2>{group.state}</h2>
          {hubBits.length ? <p className="home-intro-links">Hubs: {hubBits}</p> : null}
          <ul className="hub-prerender-rooms">
            {group.rooms.map(function(name) {
              return (
                <li key={name}>
                  <Link to={'/allcasinos/' + encodeSlug(name)}>{name}</Link>
                </li>
              );
            })}
          </ul>
        </section>
      );
    });
    return (
      <article className="content-page guide-page">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">{INDEX.h1}</h1>
        <p className="content-lead">{INDEX.lead}</p>
        {groups}
        <p className="content-cta">
          <Link to="/guides/poker-tournament-faq">Poker tournament FAQ</Link>
          {' · '}
          <Link to="/about">About &amp; data sources</Link>
          {' · '}
          <Link to="/">Search schedules</Link>
        </p>
      </article>
    );
  }
});

module.exports = AllRooms;



// WEBPACK FOOTER //
// ./js/pages/all-rooms.jsx